import { render } from "./StickyHeader.vue?vue&type=template&id=4c06b97a&scoped=true"
import script from "./StickyHeader.vue?vue&type=script&lang=js"
export * from "./StickyHeader.vue?vue&type=script&lang=js"

import "./StickyHeader.vue?vue&type=style&index=0&id=4c06b97a&scoped=true&lang=scss"
import "./StickyHeader.vue?vue&type=style&index=1&id=4c06b97a&lang=scss"
script.render = render
script.__scopeId = "data-v-4c06b97a"

export default script